import React from 'react';
import styled, { css } from 'styled-components';
import Required from './required';

const InputLabel = ({ required, children, ...props }) => (
  <span {...props}>{children}{required && <Required />}</span>
);

export default styled(InputLabel)`
  ${({ $type }) => $type !== 'textarea' && css`
    margin-top: 0.6rem;
    
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      margin-top: 0;
    }
  `}
`;
